import React from "react";
import { highlightText } from "../../../util/highlightText";
import { IProductTileProps } from "../../../types/suggestion-items";
import { ITelemetryData } from "../../../types/telemetry";
import { sendTelemetryData } from "../../../util/telemetry";
import { useL10nContext, useNavigationContext } from "../../common/contexts";
import ArticlePrice from "./article-price/article-price";
import FlexibleImageGrid from "./flexible-image-grid/flexible-image-grid";

const ProductTile = (props: IProductTileProps) => {
    const { handleMouseSelect, handleMouseDeselect, handleTouched } = useNavigationContext();
    const { decodeVariantsL10n, imageMainView } = useL10nContext();
    const variantsL10n = decodeVariantsL10n();

    const anchorName = `ssw-suggested-${props.article.type.toLowerCase()}-${props.index}`;
    const imageAltText = `${imageMainView}, ${props.article.title}`;

    const variantString = () => {
        if (props.article.availableColorsCount > 0) {
            const colorLabel =
                props.article.availableColorsCount > 1 ? variantsL10n.colors : variantsL10n.color;
            return `${props.article.availableColorsCount} ${colorLabel}`;
        } else if (props.article.availableModelsCount > 0) {
            const modelLabel =
                props.article.availableModelsCount > 1
                    ? variantsL10n.variants
                    : variantsL10n.variant;
            return `${props.article.availableModelsCount} ${modelLabel}`;
        } else return "";
    };

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        handleTouched(props.article.navIndex);
        recordProductUsed();
        window.location.href = props.article.target;
    };

    const recordProductUsed = () => {
        const data: ITelemetryData = {
            correlationId: props.searchInfo.pageViewLogDataId,
            culture: props.searchInfo.culture,
            portal: props.searchInfo.portal,
            searchTerm: props.searchInfo.searchTerm,
            shortLink: props.article.shortLink,
            suggestion: props.article.title,
            contentType: props.article.type
        };
        sendTelemetryData(data, props.searchInfo.trackingEndpoint);
    };

    return (
        <div
            ref={(el) => props.setRef(props.article.navIndex, el)}
            onMouseEnter={() => handleMouseSelect(props.article.navIndex)}
            onMouseLeave={handleMouseDeselect}
            className={`suggestion-item ${props.article.type.toLowerCase()}`}
        >
            <a
                className={anchorName}
                href={props.article.target}
                onClick={handleClick}
                data-testid={anchorName}
                data-semantic-id={anchorName}
            >
                {props.hideProductInfo ? (
                    <div className="article-info">
                        <span className="article-name">
                            {highlightText(props.article.title, props.searchInfo.searchTerm)}
                        </span>
                    </div>
                ) : (
                    <>
                        <FlexibleImageGrid
                            article={props.article}
                            set={null}
                            imageMainView={imageAltText}
                        />
                        <div className="article-info">
                            <span className="article-name">
                                {highlightText(props.article.title, props.searchInfo.searchTerm)}
                            </span>
                            {props.showPrices ? (
                                props.article.price && (
                                    <ArticlePrice
                                        prices={props.article.price}
                                        priceSettings={props.priceMandantSettings}
                                    />
                                )
                            ) : (
                                <div className="article-variants">{variantString()}</div>
                            )}
                        </div>
                    </>
                )}
            </a>
        </div>
    );
};

export default ProductTile;
